import { RgbaColor } from 'react-colorful';

export const hexToRgba = (hex: string): RgbaColor => {
    // Remove '#' if present
    hex = hex.replace('#', '');

    // Extract individual color components
    const red = parseInt(hex.substring(0, 2), 16);
    const green = parseInt(hex.substring(2, 4), 16);
    const blue = parseInt(hex.substring(4, 6), 16);
    let alpha = 1; // default alpha value

    // If hex length is 8, it contains alpha information
    if (hex.length === 8) {
        alpha = parseInt(hex.substring(6, 8), 16) / 255;
    }

    // Return RGBA object
    return {
        r: red,
        g: green,
        b: blue,
        a: alpha,
    };
};
